export default __webpack_public_path__ + "1a8da9ec587b9d58465f2cbccd4adb3f.png";